//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TABLET } from '@/scripts/constants/media-query'

export default {
  name: 'rb-combo-boards',
  props: {
    fullScreenMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    slideSlot() {
      return this.$slots.tiles.filter((slot) => !!slot.tag)
    },
    isTablet() {
      return this.$mq === TABLET
    },
    bannersCount() {
      return this.$slots['banners'].filter((b) => b.tag).length
    },
  },
}
